import "./_style.scss";
import TkStepper from "../../components/atoms/TkStepper";
import {
  DemanderKbn,
  DemanderRelationship,
  DispDepositType,
  FormClassRetire,
  FormKbn,
  Prefectures,
  RetireReason,
  Status,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { Box } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { useContext, useEffect, useRef, useState } from "react";
import { BusinessContext } from "../../context/businessContext";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import {
  bereavedStepper,
  fakeTableList,
  heirStepper,
  retireeStepper,
  schema,
} from "./parts";
import { TkGetCode } from "../../utils/TkGetCode";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_RET004, httpAPI_COM014 } from "./api/request";
import { httpAPI_RET005 } from "./api/request.formdata";
import { IAPI_RET005_Request } from "../../type/apiType";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import { messageids } from "../../assets/data/TkMessageProperty";
import _ from "lodash";

/**
 * SCRR410016 退職手当金の請求手続き（登録内容の確認）
 * @return SCRR410016 退職手当金の請求手続き（登録内容の確認）
 */
const SCRR410016 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const [downloadedFileMap, setDownloadedFileMap] = useState<
    Record<string, string>
  >({});
  const [open, setOpen] = useState(false);
  const [steps, setsteps] = useState(0);
  const [showButton, setShowButton] = useState(true);
  const [steppper, setStepper] = useState<string[]>([]);
  const [saveStep, setSaveStep] = useState<any>();
  let rotationData = businessState.job_35 ?? {};

  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const isHojin = userType === authorityUserType.userTypeNumber.KEIYAKUSYA;
  const requestContrcatorNo = isKiko
    ? businessState.common?.contractorNo!
    : state.authInfo?.contractorNo!;

  const [httpReq, setHttpReq] = useState<IAPI_RET005_Request>({});
  const [warning, setWarning] = useState(false);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [isRetiree, setIsRetiree] = useState(false);

  const handleInit = async () => {
    let resData = null;

    if (location.state?.applyId) {
      try {
        const res = await httpAPI_RET004({
          applyId: location.state?.applyId,
          contractorNo: state?.authInfo?.contractorNo,
        });

        if (res.resultCd === "I0000") {
          rotationData = res;
          resData = res;

          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          rotationData = {};

          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }

    let resArr = stateFakeTableList.current;

    //　退職者名
    const retireeName = resArr.find((item) => item.keyword === "retireeName")!;
    retireeName.contractorNumber = rotationData.retirementStaffName;
    retireeName.showLine = isKiko;

    //勤務先
    resArr.find((item) => item.keyword === "facilityName")!.text =
      rotationData.facilityName;

    const isRetiree = rotationData?.demanderKbn === DemanderKbn["退職者本人"];
    setIsRetiree(isRetiree);
    //退職者氏名
    resArr.find((item) => item.keyword === "retirementStaffName")!.text =
      rotationData.retirementStaffName;

    //生年月日
    resArr.find((item) => item.keyword === "birthday")!.text =
      rotationData.birthday;

    //被共済職員期間
    resArr.find((item) => item.keyword === "maePeriod")!.text =
      (rotationData.maePeriodYear ?? "") +
      "年" +
      (rotationData.maePeriodMonth ?? "") +
      "ヵ月";

    //退職日
    resArr.find((item) => item.keyword === "retireDate")!.text =
      rotationData.retireDate;

    //退職理由
    resArr.find(
      (item) => item.keyword === "retirementReason"
    )!.setDefaultValue = rotationData.retirementReason;

    //請求者区分
    resArr.find((item) => item.keyword === "demanderKbn")!.setDefaultValue =
      rotationData.demanderKbn;

    /**
     * isShowline start
     */

    // 「請求者区分」が「遺族」または「相続人」の場合表示
    const isShowline =
      location.state?.applyId ||
      rotationData.demanderKbn === DemanderKbn["相続人"] ||
      rotationData.demanderKbn === DemanderKbn["遺族"];

    //続柄
    let demanderRelationship = resArr.find(
      (item) => item.keyword === "demanderRelationship"
    )!;
    demanderRelationship.setDefaultValue = rotationData.demanderRelationship;
    demanderRelationship.showLine = isShowline;

    //続柄が「その他」を選択する場合
    if (rotationData.demanderRelationship === DemanderRelationship["その他"]) {
      //「その他」入力欄
      let demanderRelationshipOthers = resArr.find(
        (item) => item.keyword === "demanderRelationshipOthers"
      )!;
      demanderRelationshipOthers.text = rotationData.demanderRelationshipOthers;
      demanderRelationshipOthers.showLine = isShowline;
    }

    //退職者からの生計維持の有無
    let livelihoodFromRetireeFlg = resArr.find(
      (item) => item.keyword === "livelihoodFromRetireeFlg"
    )!;
    livelihoodFromRetireeFlg.setDefaultValue =
      rotationData.livelihoodFromRetireeFlg;
    livelihoodFromRetireeFlg.showLine = isShowline;

    // あなたと同順位の請求権保持者の有無
    let demanderFlg = resArr.find((item) => item.keyword === "demanderFlg")!;
    demanderFlg.setDefaultValue = rotationData.demanderFlg;
    demanderFlg.showLine = isShowline;

    /**
     * isShowline end
     */

    // 請求者氏名（ｶﾅ）
    resArr.find(
      (item) => item.keyword === "demanderNameKana"
    )!.setDefaultValue = rotationData.demanderNameKana;

    // 請求者氏名（全角漢字）
    resArr.find((item) => item.keyword === "demanderName")!.setDefaultValue =
      rotationData.demanderName;

    // 請求者生年月日
    resArr.find((item) => item.keyword === "demanderBirth")!.setDefaultValue =
      rotationData.demanderBirth;

    // 請求者現住所（郵便番号）
    resArr.find((item) => item.keyword === "demanderZipcode")!.setDefaultValue =
      rotationData.demanderZipcode;

    // 請求者現住所
    resArr.find((item) => item.keyword === "demanderAddress")!.valueObject = {
      prefectures: TkGetCode(Prefectures, rotationData.demanderPrefectureCd),
      city: rotationData.demanderCity ?? "",
      address: rotationData.demanderAddressOthers ?? "",
    };

    // 請求者連絡先
    resArr.find((item) => item.keyword === "tel")!.setDefaultValue =
      rotationData.tel;

    // 請求者メールアドレス（機構連絡用）
    resArr.find((item) => item.keyword === "demanderEmail")!.setDefaultValue =
      rotationData.demanderEmail;

    // 代行者連絡先メールアドレス
    let agentEmail = resArr.find((item) => item.keyword === "agentEmail")!;
    agentEmail.showLine = isHojin;
    agentEmail.setDefaultValue = rotationData.agentEmail;

    // 金融機関コード
    resArr.find((item) => item.keyword === "bankCd")!.text =
      rotationData.bankCd;

    // 金融機関名
    resArr.find((item) => item.keyword === "bankName")!.text =
      rotationData.bankName;

    // 支店コード
    resArr.find((item) => item.keyword === "branchCd")!.text =
      rotationData.branchCd;

    // 支店名
    resArr.find((item) => item.keyword === "branchName")!.text =
      rotationData.branchName;

    // 預金種目
    let depositType = resArr.find((item) => item.keyword === "depositType")!;
    if (rotationData.depositType === DispDepositType["普通"]) {
      depositType.setDefaultValue = DispDepositType["普通"];
    }

    // 口座番号
    resArr.find((item) => item.keyword === "accountNo")!.setDefaultValue =
      rotationData.accountNo;

    resArr.find((item) => item.keyword === "accountNameKana")!.setDefaultValue =
      rotationData.accountNameKana;

    // 海外送金
    let sendMoneyAbroad = resArr.find(
      (item) => item.keyword === "sendMoneyAbroad"
    )!;
    // 国内居住の有無による
    (rotationData?.sendMoneyAbroad === "1" ||
      (rotationData.domesticResidenceFlg && !rotationData.depositType)) &&
      (sendMoneyAbroad.setDefaultValue = ["海外送金"]);
    sendMoneyAbroad.showLine = isKiko;

    // 国内居住
    let domesticResidenceFlg = resArr.find(
      (item) => item.keyword === "domesticResidenceFlg"
    )!;
    domesticResidenceFlg.showLine = isKiko;
    domesticResidenceFlg.setDefaultValue = rotationData.domesticResidenceFlg;

    //「死亡診断書」又は「死体検案書」（写）
    let deathOrAutopsyReport = resArr.find(
      (item) => item.keyword === "deathOrAutopsyReport"
    )!;

    // 内縁関係についての「生計維持に関する調査書」（様式１１号）
    let marriageReport = resArr.find(
      (item) => item.keyword === "marriageReport"
    )!;

    // 職員の死亡を証する「戸籍謄本」又は「除籍謄本」
    let certifiedCertificateResidence = resArr.find(
      (item) => item.keyword === "certifiedCertificateResidence"
    )!;

    // その他、事実上の配偶者であることを証明する書類
    let claimantPartnerBook = resArr.find(
      (item) => item.keyword === "claimantPartnerBook"
    )!;

    // 確認する書類の選択
    let identifyDocsKind = resArr.find(
      (item) => item.keyword === "identificationDocsKind"
    )!;
    identifyDocsKind.setDefaultValue = rotationData.identificationDocsKind;
    identifyDocsKind.showLine = true;

    // 死亡した退職者の個人番号を確認する書類
    let deceasedRetireeNumCheckDoc = resArr.find(
      (item) => item.keyword === "deceasedRetireeNumCheckDoc"
    )!;

    // 本人であることを確認するための書類1
    let identityDocs1 = resArr.find(
      (item) => item.keyword === "identityDocs1"
    )!;
    // 本人であることを確認するための書類2
    let identityDocs2 = resArr.find(
      (item) => item.keyword === "identityDocs2"
    )!;

    // 本人であることを確認するための書類（表）
    let identityDocHead = resArr.find(
      (item) => item.keyword === "identityDocHead"
    )!;

    // 本人であることを確認するための書類（裏）
    let identityDocTail = resArr.find(
      (item) => item.keyword === "identityDocTail"
    )!;

    // 旧姓と新姓が確認できる書類
    let nameConfirmation = resArr.find(
      (item) => item.keyword === "nameConfirmation"
    )!;

    // 個人番号を確認する書類：ダウンロードリンク
    let numberCheckDoc = resArr.find(
      (item) => item.keyword === "numberCheckDoc"
    )!;

    // 振込先口座が確認できる書類
    let payAccountCheckDoc = resArr.find(
      (item) => item.keyword === "payAccountCheckDoc"
    )!;

    // 委任状
    let commission = resArr.find((item) => item.keyword === "commission")!;

    // 法人が添付した源泉徴収票（1枚目）
    let attachedTax1 = resArr.find((item) => item.keyword === "attachedTax1")!;

    // 法人が添付した源泉徴収票（2枚目）
    let attachedTax2 = resArr.find((item) => item.keyword === "attachedTax2")!;

    // 法人が添付した源泉徴収票（3枚目）
    let attachedTax3 = resArr.find((item) => item.keyword === "attachedTax3")!;

    // (1枚目)退職所得の源泉徴収票
    let page1RetireeTax = resArr.find(
      (item) => item.keyword === "page1RetireeTax"
    )!;

    // (1枚目)就労年月日
    resArr.find(
      (item) => item.keyword === "page1EmployedDate"
    )!.setDefaultValue = rotationData.page1EmployedDate;

    // (1枚目)退職年月日
    resArr.find(
      (item) => item.keyword === "page1RetiredDate"
    )!.setDefaultValue = rotationData.page1RetiredDate;

    // (1枚目)区分
    resArr.find((item) => item.keyword === "page1Kbn")!.setDefaultValue =
      rotationData.page1Kbn;

    // (1枚目)支払金額
    resArr.find((item) => item.keyword === "page1PaymentAmt")!.setDefaultValue =
      rotationData.page1PaymentAmt;

    // (1枚目)源泉徴収額
    resArr.find(
      (item) => item.keyword === "page1WithholdingAmt"
    )!.setDefaultValue = rotationData.page1WithholdingAmt;

    // (1枚目)特別徴収税額:市町村民税
    resArr.find((item) => item.keyword === "page1ScAmtCity")!.setDefaultValue =
      rotationData.page1ScAmtCity;

    // (1枚目)特別徴収税額:都道府県税
    resArr.find(
      (item) => item.keyword === "page1ScAmtPrefecture"
    )!.setDefaultValue = rotationData.page1ScAmtPrefecture;

    // (1枚目)勤続年数
    resArr.find(
      (item) => item.keyword === "page1LengthOfService"
    )!.setDefaultValue = rotationData.page1LengthOfService;

    // （1枚目）控除期間（年）
    resArr.find(
      (item) => item.keyword === "page1DeductionPeriodYear"
    )!.setDefaultValue = rotationData.page1DeductionPeriodYear;

    // （1枚目）控除期間（月）
    resArr.find(
      (item) => item.keyword === "page1DeductionPeriodMonth"
    )!.setDefaultValue = rotationData.page1DeductionPeriodMonth;

    //(2枚目)就労年月日
    let page2EmployedDate = resArr.find(
      (item) => item.keyword === "page2EmployedDate"
    )!;
    page2EmployedDate.setDefaultValue = rotationData.page2EmployedDate;
    page2EmployedDate.showLine = !!rotationData.page2EmployedDate;

    // (2枚目)退職所得の源泉徴収票
    let page2RetireeTax = resArr.find(
      (item) => item.keyword === "page2RetireeTax"
    )!;

    // (2枚目)退職年月日
    let page2RetiredDate = resArr.find(
      (item) => item.keyword === "page2RetiredDate"
    )!;
    page2RetiredDate.setDefaultValue = rotationData.page2RetiredDate;
    page2RetiredDate.showLine = !!rotationData.page2RetiredDate;

    // (2枚目)区分
    let page2Kbn = resArr.find((item) => item.keyword === "page2Kbn")!;
    page2Kbn.setDefaultValue = rotationData.page2Kbn;
    page2Kbn.showLine = !!rotationData.page2Kbn;

    // (2枚目)支払金額
    let page2PaymentAmt = resArr.find(
      (item) => item.keyword === "page2PaymentAmt"
    )!;
    page2PaymentAmt.setDefaultValue = rotationData.page2PaymentAmt;
    page2PaymentAmt.showLine = !!rotationData.page2PaymentAmt;

    // (2枚目)源泉徴収額
    let page2Tax = resArr.find((item) => item.keyword === "page2Tax")!;
    page2Tax.setDefaultValue = rotationData.page2WithholdingAmt;
    page2Tax.showLine = !!rotationData.page2PaymentAmt;

    // (2枚目)特別徴収税額:市町村民税
    let page2ScAmtCity = resArr.find(
      (item) => item.keyword === "page2ScAmtCity"
    )!;
    page2ScAmtCity.setDefaultValue = rotationData.page2ScAmtCity;
    page2ScAmtCity.showLine = !!rotationData.page2ScAmtCity;

    // (2枚目)特別徴収税額:都道府県税
    let page2ScAmtPrefecture = resArr.find(
      (item) => item.keyword === "page2ScAmtPrefecture"
    )!;
    page2ScAmtPrefecture.setDefaultValue = rotationData.page2ScAmtPrefecture;
    page2ScAmtPrefecture.showLine = !!rotationData.page2ScAmtPrefecture;

    // (2枚目)勤続年数
    let page2LengthOfService = resArr.find(
      (item) => item.keyword === "page2LengthOfService"
    )!;
    page2LengthOfService.setDefaultValue = rotationData.page2LengthOfService;
    page2LengthOfService.showLine = !!rotationData.page2LengthOfService;

    // （2枚目）控除期間（年）
    let page2DeductionPeriodYear = resArr.find(
      (item) => item.keyword === "page2DeductionPeriodYear"
    )!;
    page2DeductionPeriodYear.setDefaultValue =
      rotationData.page2DeductionPeriodYear;
    page2DeductionPeriodYear.showLine = !!rotationData.page2DeductionPeriodYear;

    // （2枚目）控除期間（月）
    let page2DeductionPeriodMonth = resArr.find(
      (item) => item.keyword === "page2DeductionPeriodMonth"
    )!;
    page2DeductionPeriodMonth.setDefaultValue =
      rotationData.page2DeductionPeriodMonth;
    page2DeductionPeriodMonth.showLine =
      !!rotationData.page2DeductionPeriodMonth;

    // 氏名
    resArr.find((item) => item.keyword === "name")!.setDefaultValue = isRetiree
      ? rotationData.demanderName
      : rotationData.staffNameKanji;

    // 現住所
    let nowAddress = resArr.find((item) => item.keyword === "nowAddress")!;
    const displayCity = isRetiree
      ? rotationData?.demanderCity
      : rotationData?.retirementAddressCity;
    const displayAdress = isRetiree
      ? rotationData?.demanderAddressOthers
      : rotationData.retirementAddressOthers;
    nowAddress.valueObject = {
      prefectures: TkGetCode(
        Prefectures,
        isRetiree
          ? rotationData.demanderPrefectureCd
          : rotationData.retirementPrefectureCd
      ),
      city: displayCity ?? "",
      address: displayAdress ?? "",
    };
    nowAddress.showLine = !!rotationData.retirementPrefectureCd;

    //その年１月１日現在の住所
    resArr.find(
      (item) => item.keyword === "yearOneToOnelocation"
    )!.valueObject = {
      prefectures: TkGetCode(
        Prefectures,
        rotationData.retirementYearFirstPrefectureCd!
      ),
      city: rotationData.retirementYearFirstAddressCity!,
      address: rotationData.retirementYearAddressOthers!,
    };

    //【A】①　退職手当等の支払を受けることとなった年月日
    let paymentConfirmDate = resArr.find(
      (item) => item.keyword === "paymentConfirmDate"
    )!;

    paymentConfirmDate.setDefaultValue = rotationData.paymentConfirmDate;

    if (rotationData.paymentConfirmDate) {
      paymentConfirmDate.showLine = true;
    }

    //【A】②　退職区分等
    let retireKbn = resArr.find((item) => item.keyword === "retireKbn")!;

    retireKbn.setDefaultValue = rotationData.retireKbn;

    if (rotationData.retireKbn) {
      retireKbn.showLine = true;
    }

    //【A】生活扶助の有無
    let livingAssistanceFlg = resArr.find(
      (item) => item.keyword === "livingAssistanceFlg"
    )!;

    livingAssistanceFlg.setDefaultValue = rotationData.livingAssistanceFlg;

    if (rotationData.livingAssistanceFlg) {
      livingAssistanceFlg.showLine = true;
    }

    //【A】③　この申告書の提出先から受ける退職手当等についての勤続期間
    let joinAndRetireDate = resArr.find(
      (item) => item.keyword === "joinAndRetireDate"
    )!;

    joinAndRetireDate.start = {
      disabled: true,
      wantToSetValue: rotationData.firstJoinDate,
    };

    joinAndRetireDate.end = {
      disabled: true,
      wantToSetValue: rotationData.retireDate,
    };

    if (rotationData.firstJoinDate) {
      joinAndRetireDate.showLine = true;
    }

    //【B】他の退職金の支払いの有無
    resArr.find((item) => item.keyword === "areaBInputCheck")!.setDefaultValue =
      rotationData.areaBInputCheck;

    //【B】④本年中に支払を受けた他の退職手当等についての勤続期間
    let ltotalCurrentYearLosFromPageB = resArr.find(
      (item) => item.keyword === "ltotalCurrentYearLosFromPageB"
    )!;

    ltotalCurrentYearLosFromPageB.start = {
      disabled: true,
      wantToSetValue: rotationData.totalCurrentYearLosFrom,
    };

    ltotalCurrentYearLosFromPageB.end = {
      disabled: true,
      wantToSetValue: rotationData.totalCurrentYearLosTo,
    };

    if (rotationData.totalCurrentYearLosFrom) {
      ltotalCurrentYearLosFromPageB.showLine = true;
    }

    //【B】⑤　③と④の通算勤続期間
    let LengthOfCommutingServicePageB = resArr.find(
      (item) => item.keyword === "LengthOfCommutingServicePageB"
    )!;

    LengthOfCommutingServicePageB.start = {
      disabled: true,
      wantToSetValue: rotationData.areaBNo5From,
    };

    LengthOfCommutingServicePageB.end = {
      disabled: true,
      wantToSetValue: rotationData.areaBNo5To,
    };

    if (rotationData.areaBNo5From) {
      LengthOfCommutingServicePageB.showLine = true;
    }

    //【C】他の退職金の支払いの有無
    resArr.find((item) => item.keyword === "areaCInputCheck")!.setDefaultValue =
      rotationData.areaCInputCheck;

    //【C】⑥　前年以前４年内に支払を受けた他の退職手当等についての勤続期間
    let past4yearsLosFrom = resArr.find(
      (item) => item.keyword === "past4yearsLosFrom"
    )!;

    past4yearsLosFrom.start = {
      disabled: true,
      wantToSetValue: rotationData.past4yearsLosFrom,
    };

    past4yearsLosFrom.end = {
      disabled: true,
      wantToSetValue: rotationData.past4yearsLosTo,
    };

    if (rotationData.past4yearsLosFrom) {
      past4yearsLosFrom.showLine = true;
    }

    //【C】⑦　③又は⑤の勤続期間のうち、⑥の勤続期間と重複している期間
    let todoone = resArr.find((item) => item.keyword === "todoone")!;

    todoone.start = {
      disabled: true,
      wantToSetValue: rotationData.areaCNo7From,
    };

    todoone.end = {
      disabled: true,
      wantToSetValue: rotationData.areaCNo7To,
    };

    if (rotationData.areaCNo7From) {
      todoone.showLine = true;
    }

    //【D】通算の有無
    let areaDInputCheck = resArr.find(
      (item) => item.keyword === "areaDInputCheck"
    )!;

    areaDInputCheck.setDefaultValue = rotationData.areaDInputCheck;

    if (rotationData.areaDInputCheck) {
      areaDInputCheck.showLine = true;
    }

    //【D】⑧　Ａの退職手当等についての勤続期間（③）に通算された前の退職手当等についての勤続期間
    let totalYearLosFrom = resArr.find(
      (item) => item.keyword === "totalYearLosFrom"
    )!;

    totalYearLosFrom.start = {
      disabled: true,
      wantToSetValue: rotationData.totalYearLosFrom,
    };

    totalYearLosFrom.end = {
      disabled: true,
      wantToSetValue: rotationData.totalYearLosTo,
    };

    if (rotationData.totalYearLosFrom) {
      totalYearLosFrom.showLine = true;
    }

    //【D】⑨　Ｂの退職手当等についての勤続期間（④）に通算された前の退職手当等についての勤続期間
    let totalCurrentYearLos = resArr.find(
      (item) => item.keyword === "totalCurrentYearLos"
    )!;

    totalCurrentYearLos.start = {
      disabled: true,
      wantToSetValue: rotationData.totalCurrentYearLosFrom,
    };

    totalCurrentYearLos.end = {
      disabled: true,
      wantToSetValue: rotationData.totalCurrentYearLosTo,
    };

    if (rotationData.totalCurrentYearLosFrom) {
      totalCurrentYearLos.showLine = true;
    }

    // 【D】⑩　③又は⑤の勤続期間のうち、⑧又は⑨の勤続期間だけからなる部分の期間
    let ServicePeriodPortionStartPageD = resArr.find(
      (item) => item.keyword === "ServicePeriodPortionStartPageD"
    )!;

    ServicePeriodPortionStartPageD.start = {
      disabled: true,
      wantToSetValue: rotationData.areaDNo10From,
    };

    ServicePeriodPortionStartPageD.end = {
      disabled: true,
      wantToSetValue: rotationData.areaDNo10To,
    };

    if (rotationData.areaDNo10From) {
      ServicePeriodPortionStartPageD.showLine = true;
    }

    //【D】⑪ ⑦と⑩の通算期間
    let sevenAndThreeCommencementOfPeriodStartPageD = resArr.find(
      (item) => item.keyword === "sevenAndThreeCommencementOfPeriodStartPageD"
    )!;

    sevenAndThreeCommencementOfPeriodStartPageD.start = {
      disabled: true,
      wantToSetValue: rotationData.areaDNo11From,
    };

    sevenAndThreeCommencementOfPeriodStartPageD.end = {
      disabled: true,
      wantToSetValue: rotationData.areaDNo11From,
    };

    if (rotationData.areaDNo11From) {
      sevenAndThreeCommencementOfPeriodStartPageD.showLine = true;
    }

    //【E】B欄又はC欄の退職手当等の有無
    let RetirementAllowancePageE = resArr.find(
      (item) => item.keyword === "RetirementAllowancePageE"
    )!;

    RetirementAllowancePageE.setDefaultValue = rotationData.areaEInputCheck;

    if (rotationData.areaEInputCheck) {
      RetirementAllowancePageE.showLine = true;
    }

    //【E】区分B　退職手当等の支払を受けることとなった年月日
    let currentYearPaymentDecisionDate = resArr.find(
      (item) => item.keyword === "currentYearPaymentDecisionDate"
    )!;
    currentYearPaymentDecisionDate.setDefaultValue =
      rotationData.currentYearPaymentDecisionDate;
    currentYearPaymentDecisionDate.showLine =
      !!rotationData.currentYearPaymentDecisionDate;

    //【E】区分B　収入金額
    let currentYearRetirementAllowanceAmt = resArr.find(
      (item) => item.keyword === "currentYearRetirementAllowanceAmt"
    )!;
    currentYearRetirementAllowanceAmt.setDefaultValue =
      rotationData.currentYearRetirementAllowanceAmt;
    currentYearRetirementAllowanceAmt.showLine =
      !!rotationData.currentYearRetirementAllowanceAmt;

    //【E】区分B　源泉徴収額
    let currentYearWithholdingAmt = resArr.find(
      (item) => item.keyword === "currentYearWithholdingAmt"
    )!;
    currentYearWithholdingAmt.setDefaultValue =
      rotationData.currentYearWithholdingAmt;
    currentYearWithholdingAmt.showLine =
      !!rotationData.currentYearWithholdingAmt;

    //【E】区分B　特別徴収税額（市町村民税）
    let currentYearScCityAmt = resArr.find(
      (item) => item.keyword === "currentYearScCityAmt"
    )!;
    currentYearScCityAmt.setDefaultValue = rotationData.currentYearScCityAmt;
    currentYearScCityAmt.showLine = !!rotationData.currentYearScCityAmt;

    //【E】区分B　特別徴収税額（都道府県民税）
    let currentYearScPrefectureAmt = resArr.find(
      (item) => item.keyword === "currentYearScPrefectureAmt"
    )!;
    currentYearScPrefectureAmt.setDefaultValue =
      rotationData.currentYearScPrefectureAmt;
    currentYearScPrefectureAmt.showLine =
      !!rotationData.currentYearScPrefectureAmt;

    //【E】区分B　支払いを受けた年月日
    let currentYearGetPaidDate = resArr.find(
      (item) => item.keyword === "currentYearGetPaidDate"
    )!;
    currentYearGetPaidDate.setDefaultValue =
      rotationData.currentYearGetPaidDate;
    currentYearGetPaidDate.showLine = !!rotationData.currentYearGetPaidDate;

    //【E】区分B　退職の区分
    let currentYearRetirementKbn = resArr.find(
      (item) => item.keyword === "currentYearRetirementKbn"
    )!;
    currentYearRetirementKbn.setDefaultValue =
      rotationData.currentYearRetirementKbn;
    currentYearRetirementKbn.showLine = !!rotationData.currentYearRetirementKbn;

    //【E】区分B　支払者の所在地（住所）（都道府県）
    let currentYearPayerAddress = resArr.find(
      (item) => item.keyword === "currentYearPayerAddress"
    )!;
    currentYearPayerAddress.valueObject = {
      prefectures: TkGetCode(
        Prefectures,
        rotationData.currentYearPayerPrefectureCd
      ),
      city: rotationData.currentYearPayerAddressOthers ?? "",
      address: rotationData.currentYearPayerAddressOthers ?? "",
    };
    currentYearPayerAddress.showLine =
      !!rotationData.currentYearPayerPrefectureCd;

    //【E】区分B　支払者の名称（氏名）(全角)
    let currentYearPayerName = resArr.find(
      (item) => item.keyword === "currentYearPayerName"
    )!;
    currentYearPayerName.setDefaultValue = rotationData.currentYearPayerName;
    currentYearPayerName.showLine = !!rotationData.currentYearPayerName;

    //【E】区分C　退職手当等の支払を受けることとなった年月日
    let past4yearsPaymentDecisionDate = resArr.find(
      (item) => item.keyword === "past4yearsPaymentDecisionDate"
    )!;
    past4yearsPaymentDecisionDate.setDefaultValue =
      rotationData.past4yearsPaymentDecisionDate;
    past4yearsPaymentDecisionDate.showLine =
      !!rotationData.past4yearsPaymentDecisionDate;

    //【E】区分C　収入金額
    let past4yearsRetirementAllowanceAmt = resArr.find(
      (item) => item.keyword === "past4yearsRetirementAllowanceAmt"
    )!;
    past4yearsRetirementAllowanceAmt.setDefaultValue =
      rotationData.past4yearsRetirementAllowanceAmt;
    past4yearsRetirementAllowanceAmt.showLine =
      !!rotationData.past4yearsRetirementAllowanceAmt;

    //【E】区分C　源泉徴収額
    let past4yearsWithholdingAmt = resArr.find(
      (item) => item.keyword === "past4yearsWithholdingAmt"
    )!;

    past4yearsWithholdingAmt.setDefaultValue =
      rotationData.past4yearsWithholdingAmt;
    past4yearsWithholdingAmt.showLine = !!rotationData.past4yearsWithholdingAmt;

    //【E】区分C　特別徴収税額（市町村民税）
    let past4yearsScCityAmt = resArr.find(
      (item) => item.keyword === "past4yearsScCityAmt"
    )!;
    past4yearsScCityAmt.setDefaultValue = rotationData.past4yearsScCityAmt;
    past4yearsScCityAmt.showLine = !!rotationData.past4yearsScCityAmt;

    //【E】区分C　特別徴収税額（都道府県民税）
    let past4yearsScPrefectureAmt = resArr.find(
      (item) => item.keyword === "past4yearsScPrefectureAmt"
    )!;
    past4yearsScPrefectureAmt.setDefaultValue =
      rotationData.past4yearsScPrefectureAmt;
    past4yearsScPrefectureAmt.showLine =
      !!rotationData.past4yearsScPrefectureAmt;

    //【E】区分C　支払いを受けた年月日
    let past4yearsGetPaidDate = resArr.find(
      (item) => item.keyword === "past4yearsGetPaidDate"
    )!;
    past4yearsGetPaidDate.setDefaultValue = rotationData.past4yearsGetPaidDate;
    past4yearsGetPaidDate.showLine = !!rotationData.past4yearsGetPaidDate;

    //【E】区分C　退職の区分
    let past4yearsRetirementKbn = resArr.find(
      (item) => item.keyword === "past4yearsRetirementKbn"
    )!;

    past4yearsRetirementKbn.setDefaultValue =
      rotationData.past4yearsRetirementKbn;
    past4yearsRetirementKbn.showLine = !!rotationData.past4yearsRetirementKbn;

    //【E】区分C　支払者の所在地（住所）
    let past4yearsPayerAddress = resArr.find(
      (item) => item.keyword === "past4yearsPayerAddress"
    )!;
    past4yearsPayerAddress.valueObject = {
      prefectures: TkGetCode(
        Prefectures,
        rotationData.past4yearsPayerPrefectureCd
      ),
      city: rotationData.past4yearsPayerAddressCity ?? "",
      address: rotationData.past4yearsPayerAddressOthers ?? "",
    };
    past4yearsPayerAddress.showLine =
      !!rotationData.past4yearsPayerPrefectureCd;

    //【E】区分C　支払者の名称（氏名）（全角）
    let past4yearsPayerName = resArr.find(
      (item) => item.keyword === "past4yearsPayerName"
    )!;
    past4yearsPayerName.setDefaultValue = rotationData.past4yearsPayerName;
    past4yearsPayerName.showLine = !!rotationData.past4yearsPayerName;

    let taxReturn = resArr.filter((_i, index) => index > 41)!;
    taxReturn.forEach((item) => {
      if (rotationData?.demanderKbn === DemanderKbn["遺族"]) {
        item.showLine = false;
      }
    });

    //入出力項目.添付が必要な書類を不足ファイルのみを表示する
    // ダウンロードリンク押下時に API で base64 を取得して即時ダウンロードする
    const attachOnClick = (element: any, f: any) => {
      element.onClick = async (ev?: any) => {
        try {
          // 既に取得済みのファイルがあれば再利用
          let fileBase64 = f.file ?? f.fileBase64 ?? null;
          let applyId;
          if (
            f.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届1枚目"] ||
            f.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届2枚目"] ||
            f.formClass === FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]
          ) {
            applyId = rotationData.retirementFormApplyId;
          } else {
            applyId = rotationData.applyId;
          }

          if (!fileBase64) {
            const res: any = await httpAPI_COM014({
              applyId: applyId,
              formKbn: f.formKbn,
              formClass: f.formClass,
            });

            if (res.resultCd === "I0000") {
              // API が直接 fileBase64 を返す場合と、formList 配下で返す場合に対応
              fileBase64 =
                res.fileBase64 ??
                (res.formList &&
                  res.formList[0] &&
                  res.formList[0].fileBase64) ??
                null;

              if (fileBase64) {
                // キャッシュしておく
                setDownloadedFileMap((prev) => ({
                  ...prev,
                  [f.formKbn ?? f.formClass ?? f.formName ?? "unknown"]:
                    fileBase64,
                }));
              } else {
                // 正常応答だがファイルが存在しない
                setState({
                  ...state,
                  errorMsgId: "W3000",
                });
                return;
              }
            } else {
              setState({
                ...state,
                errorMsgId: res.resultCd,
              });
              return;
            }
          }

          // ダウンロード処理: base64 -> Blob -> ダウンロード
          if (fileBase64) {
            const mimeMatch = fileBase64.match(/^data:(.*?);base64,/);
            const mimeType = mimeMatch
              ? mimeMatch[1]
              : "application/octet-stream";
            const base64Data = fileBase64.replace(/^data:.*;base64,/, "");

            const extension = mimeType ? "." + mimeType.split("/")[1] : "";
            let fileName = f.fileName ?? f.formName ?? "file";
            fileName = fileName.includes(".") ? fileName : fileName + extension;

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });

            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.target = "_blank";
            link.rel = "nofollow noopener noreferrer";
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          }
        } catch (error) {
          navigate("/error");
        }
      };
      // コンポーネント側の自動ダウンロードを無効化して二重ダウンロードを防止する
      element.downloadBase64 = false;
    };

    if (rotationData.fileList) {
      rotationData.fileList.forEach((file: any) => {
        if (file.formKbn !== FormKbn["退職書類"]) {
          return;
        } //帳票区分が"6"「退職書類」以外は何もしない

        switch (file.formClass) {
          case FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]:
            deathOrAutopsyReport.showLine = true;
            deathOrAutopsyReport.dataname = file.fileName ?? file.formName;
            deathOrAutopsyReport.base64filedata =
              file?.fileBase64 ?? file?.file;
            attachOnClick(deathOrAutopsyReport, file);
            break;
          case FormClassRetire["生計維持に関する調査書（様式11号）"]:
            marriageReport.showLine = true;
            marriageReport.dataname = file.fileName ?? file.formName;
            marriageReport.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(marriageReport, file);
            break;
          case FormClassRetire["職員の死亡当時の住民票の謄本"]:
            certifiedCertificateResidence.showLine = true;
            certifiedCertificateResidence.dataname =
              file.fileName ?? file.formName;
            certifiedCertificateResidence.base64filedata =
              file?.fileBase64 ?? file?.file;
            attachOnClick(certifiedCertificateResidence, file);
            break;
          case FormClassRetire["事実上の配偶者であることを証明する書類"]:
            claimantPartnerBook.showLine = true;
            claimantPartnerBook.dataname = file.fileName ?? file.formName;
            claimantPartnerBook.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(claimantPartnerBook, file);
            break;
          case FormClassRetire["本人確認書類"]: {
            const identityDocsList = rotationData.fileList?.filter(
              (fileData) =>
                fileData.formClass === FormClassRetire["本人確認書類"]
            );
            if (identityDocs1.showLine) {
              if (identityDocsList?.length === 2) {
                identityDocs2.showLine = true;
                identityDocs2.dataname =
                  identityDocsList[1].fileName ?? identityDocsList[1].formName;
                identityDocs2.base64filedata = identityDocsList[1]?.fileBase64
                  ? identityDocsList[1]?.fileBase64
                  : identityDocsList[1]?.file;
                attachOnClick(identityDocs2, identityDocsList[1]);
              }
            } else {
              if (identityDocsList) {
                identityDocs1.showLine = true;
                identityDocs1.dataname =
                  identityDocsList[0]?.fileName ?? identityDocsList[0].formName;
                identityDocs1.base64filedata = identityDocsList[0]?.fileBase64
                  ? identityDocsList[0]?.fileBase64
                  : identityDocsList[0]?.file;
                attachOnClick(identityDocs1, identityDocsList[0]);
              }
            }
            break;
          }
          case FormClassRetire["本人確認書類（表面）"]:
            identityDocHead.showLine = true;
            identityDocHead.dataname = file.fileName ?? file.formName;
            identityDocHead.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(identityDocHead, file);
            break;
          case FormClassRetire["本人確認書類（裏面）"]:
            identityDocTail.showLine = true;
            identityDocTail.dataname = file.fileName ?? file.formName;
            identityDocTail.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(identityDocTail, file);
            break;
          case FormClassRetire["旧姓と新姓が確認できる住民票"]:
            nameConfirmation.showLine = true;
            nameConfirmation.dataname = file.fileName ?? file.formName;
            nameConfirmation.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(nameConfirmation, file);
            break;
          case FormClassRetire["個人番号を確認する書類"]:
            numberCheckDoc.showLine = true;
            numberCheckDoc.dataname = file.fileName ?? file.formName;
            numberCheckDoc.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(numberCheckDoc, file);
            break;
          case FormClassRetire["振込先口座が確認できる書類"]:
            payAccountCheckDoc.showLine = true;
            payAccountCheckDoc.dataname = file.fileName ?? file.formName;
            payAccountCheckDoc.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(payAccountCheckDoc, file);
            break;
          case FormClassRetire["死亡した退職者の個人番号を確認する書類"]:
            deceasedRetireeNumCheckDoc.showLine = true;
            deceasedRetireeNumCheckDoc.dataname =
              file.fileName ?? file.formName;
            deceasedRetireeNumCheckDoc.base64filedata =
              file?.fileBase64 ?? file?.file;
            attachOnClick(deceasedRetireeNumCheckDoc, file);
            break;
          case FormClassRetire["委任状"]:
            commission.showLine = true;
            commission.dataname = file.fileName ?? file.formName;
            commission.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(commission, file);
            break;
          case FormClassRetire["退職所得の源泉徴収票_手当金請求1枚目"]:
            page1RetireeTax.dataname = file.fileName ?? file.formName;
            page1RetireeTax.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(page1RetireeTax, file);
            break;
          case FormClassRetire["退職所得の源泉徴収票_手当金請求2枚目"]:
            page2RetireeTax.showLine = true;
            page2RetireeTax.dataname = file.fileName ?? file.formName;
            page2RetireeTax.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(page2RetireeTax, file);
            break;
          case FormClassRetire["退職所得の源泉徴収票_退職届1枚目"]:
            attachedTax1.showLine = true;
            attachedTax1.dataname = file.fileName ?? file.formName;
            attachedTax1.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(attachedTax1, file);
            break;
          case FormClassRetire["退職所得の源泉徴収票_退職届2枚目"]:
            attachedTax2.showLine = true;
            attachedTax2.dataname = file.fileName ?? file.formName;
            attachedTax2.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(attachedTax2, file);
            break;
          case FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]:
            attachedTax3.showLine = true;
            attachedTax3.dataname = file.fileName ?? file.formName;
            attachedTax3.base64filedata = file?.fileBase64 ?? file?.file;
            attachOnClick(attachedTax3, file);
            break;
        }
      });
    }

    setSaveStep(rotationData?.tempSaveStep);
    const stepperConfig = {
      "1": { stepper: retireeStepper, steps: 9 },
      "2": { stepper: heirStepper, steps: 10 },
      "3": { stepper: bereavedStepper, steps: 6 },
      default: { stepper: heirStepper, steps: 10 },
    };

    if (rotationData.demanderKbn) {
      const { stepper, steps } =
        stepperConfig[rotationData.demanderKbn as keyof typeof stepperConfig] ||
        stepperConfig.default;
      setStepper(stepper);
      setsteps(steps);
    }

    if (resData) {
      const excludedStatuses = [Status["届出待ち"], Status["差戻し一時保存"]];
      if (excludedStatuses.includes(resData.latestApplyStatus as Status)) {
        setShowButton(true);
      } else {
        setShowButton(false);
        if (rotationData.demanderKbn === "1") {
          setStepper(retireeStepper);
          setsteps(10);
        } else if (rotationData.demanderKbn === "2") {
          setStepper(heirStepper);
          setsteps(11);
        } else if (rotationData.demanderKbn === "3") {
          setStepper(bereavedStepper);
          setsteps(7);
        }
      }
    }

    setStateTableList([...resArr]);
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...businessState.job_35,
      fileList: businessState.job_35?.fileList ?? [],
      tempSaveStep: null as any,
      businessType: businessState.common?.businessType, // 業務タイプ
      contractorNo: requestContrcatorNo, // 共済契約者番号
      nowZipcode: isRetiree
        ? businessState.job_35?.demanderZipcode
        : businessState.job_35?.retirementZipcode, // 現住所（郵便番号）
      nowPrefectureCd: isRetiree
        ? businessState.job_35?.demanderPrefectureCd
        : businessState.job_35?.retirementPrefectureCd, // 現住所（都道府県）
      nowAddressCity: isRetiree
        ? businessState.job_35?.demanderCity
        : businessState.job_35?.retirementAddressCity, // 現住所（市区町村）
      nowAddressOthers: isRetiree
        ? businessState.job_35?.demanderAddressOthers
        : businessState.job_35?.retirementAddressOthers, // 現住所（その他）
      screenId: "SCRR410016",
    };

    return API_RET005_BuildReqParams(reqObj);
  };

  const handleOk = async (date?: any) => {
    //退職手当金請求更新API実行
    try {
      httpReq.tempSaveStep = undefined;
      const res = await httpAPI_RET005({
        ...httpReq,
        receptionDate: date,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onCheckAndSubmit = () => {
    setHttpReq({ ...makeHttpObj() });

    //業務チェック
    if (rotationData.retirementReason === RetireReason["犯罪等による退職"]) {
      setWarning(true);
      return;
    }

    setOpen(true);
  };

  return (
    <Box data-testid="SCRR410016PageForTest">
      <TkStepper steps={steppper} activeStep={steps} savaStep={saveStep} />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLR410016_01}</TkInfoManual>

      {isKiko && (
        <Box className="contractorName">
          <TkContractorAndNumberLine
            name="契約者（法人）名"
            no={
              businessState.common?.contractorNo +
              ":" +
              businessState.common?.contractorName
            }
          />
        </Box>
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={showButton}
        submitButtonText={isKiko ? "申請" : "機構へ提出する"}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={onCheckAndSubmit}
      />

      <TkMessageDialog
        open={warning}
        onOky={() => {
          setOpen(true);
          setWarning(false);
        }}
        onCancel={() => setWarning(false)}
        title="警告"
        contextText={messageids.messageid.TKMSG_SCR0009W}
        okText="確認"
        cancelText="戻る"
      />

      {isKiko ? (
        <TkDateDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRR410016;
